import styled from 'styled-components';

const PercentRequired = styled.div`
  display: flex;
  flex-direction: column;
`;

export default PercentRequired;
